import { Stack, Typography } from "@mui/material";
import * as React from "react";

export const DashboardChartCard = ({ title, action, isEmpty, children }) => {
  return (
    <Stack
      sx={{
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        gap: "16px",
        mb: "24px",
      }}
    >
      <Stack
        sx={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          p: "24px",
          gap: "12px",
        }}
      >
        <Typography variant="subtitle2" fontWeight={600}>
          {title}
        </Typography>
        {!isEmpty && action}
      </Stack>
      {isEmpty ? (
        <Stack
          sx={{
            height: "361px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography color="text.secondary">
            No data found for the selected date range
          </Typography>
        </Stack>
      ) : (
        children
      )}
    </Stack>
  );
};
